var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("program-head", { attrs: { isNeedBack: false } }),
      _vm._v(" "),
      _c("empty-info", { attrs: { icon: _vm.icon } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }